import BaseApi from './BaseApi';

import { ICreateFilterProps } from 'models';

export class FilterApi extends BaseApi {
	constructor() {
		super('/filter/filter-presets');
	}
	get() {
		return this.httpClient.get({
			conditions: { auth: true },
		});
	}
	create(body: ICreateFilterProps) {
		return this.httpClient.post({
			conditions: { auth: true },
			body,
		});
	}
	delete(id: string) {
		return this.httpClient.delete({
			url: `/${id}`,
			conditions: { auth: true },
		});
	}
}
export const FilterService = new FilterApi();
